import Vehicle from '@/models/vehicle'
import VehicleList from '@/models/vehicleList'

const COMPAREDATA_KEY = 'compared_vehicles'

// Helper functions for localStorage
function getData () {
  // Get serialized data from localStorage
  if (localStorage.getItem(COMPAREDATA_KEY)) {
    const comparedVehicles = JSON.parse(localStorage.getItem(COMPAREDATA_KEY) || '')
    return comparedVehicles

  // If data does not exist (yet), return default data
  } else {
    return []
  }
}

function saveData () {
  // Save serialized data in localStorage
  localStorage.setItem(COMPAREDATA_KEY, JSON.stringify(state.vehicles.items))
}

// initial state
const state = {
  vehicles: {
    items: getData()
  }
}

// getters
const getters = {
  vehicles: (state: any) => {
    return state.vehicles.items
  }
}

const mutations = {
  addVehicle: (state: any, vehicle: Vehicle) => {
    if (!state.vehicles.items.includes(vehicle.id)) {
      state.vehicles.items.push(vehicle.id)
      saveData()
    }
  },

  removeVehicle: (state: any, vehicle: Vehicle) => {
    const vehicleIndex = state.vehicles.items.indexOf(vehicle.id)
    state.vehicles.items.splice(vehicleIndex, 1)
    saveData()
  },

  removeDeletedVehicles: (state: any, vehicles: any) => {
    // Remove any vehicle that is still in localStorage, but does not exist anymore in vehicleList
    for (let index = (state.vehicles.items.length - 1); index >= 0; index--) {
      const vehicleId = state.vehicles.items[index]
      if (vehicles.find((v: any) => v.id === vehicleId) === undefined) {
        state.vehicles.items.splice(index, 1)
      }
    }
    saveData()
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
